/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SiffletAgentDatasourceJobParams = {
    category: SiffletAgentDatasourceJobParams.category;
};

export namespace SiffletAgentDatasourceJobParams {

    export enum category {
        JDBC = 'JDBC',
    }


}
